module.exports = __webpack_public_path__ + "static/7-492d4aa854a2f263f0785e91c082e483.svg";